import { Injectable } from "@angular/core";
import { EventLoggingParams, LogEventKey } from "src/app/interfaces/log";
import { CabinetLogEvent } from "src/app/interfaces/log/cabinet-log";
import { Step } from "src/app/pages/cabinet/letter/letter.component";
import { LogService } from "../log.service";

@Injectable({
  providedIn: 'root'
})
export class CabinetLogService {
  constructor(private logService: LogService) {
    
  }

  private referralId: number | undefined;
  private referralPadId: string | undefined; // 5자리 padStart 들어간 id
  private referralMethod: string | undefined; // 'instagram', 'copy'
  private referralUniqueName: string | undefined;

  setReferralId(id: number | undefined): void {
    this.referralId = id;
    if (id !== undefined) {
      this.referralPadId = `${id}`.padStart(5, '0');
    }
  }
  setReferralMethod(method: string | undefined): void {
    this.referralMethod = method;
  }
  setReferralUniqueName(uniqueName: string | undefined): void {
    this.referralUniqueName = uniqueName;
  }

  //[캐비넷 쪽지 보내기] 화면 진입
  logCabinetSendLetterViewed(themeColor: string, question: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_SEND_LETTER_VIEWED, { themeColor, question });
  }
  // [캐비넷 쪽지 보내기] 다음 버튼 클릭
  logCabinetSendLetterNextButtonClicked(content: string = ''): void {
    this.eventLogging(CabinetLogEvent.CABINET_SEND_LETTER_NEXT_BUTTON_CLICKED, {content})
  }
  // [캐비넷 쪽지 보내기] 나도 만들기 버튼 클릭
  logCabinetSendLetterCabinetCreateButtonClicked(stage: Step): void {
    this.eventLogging(CabinetLogEvent.CABINET_SEND_LETTER_CABINET_CREATE_BUTTON_CLICKED, {stage})
  }
  // [캐비넷 쪽지 보내기] 편지지 선택
  logCabinetSendLetterLetterImageSelected(imageId: number): void {
    this.eventLogging(CabinetLogEvent.CABINET_SEND_LETTER_LETTER_IMAGE_SELECTED, {imageId})
  }
  // [캐비넷 쪽지 보내기] 쪽지 보내기 버튼 클릭
  logCabinetSendLetterSubmit(hasHint: boolean): void {
    this.eventLogging(CabinetLogEvent.CABINET_SEND_LETTER_SUBMIT, {hasHint})
  }
  // [캐비넷 쪽지 보내기] 쪽지 더 보내기 버튼 클릭
  logCabinetSendLetterMoreButtonClicked(hasHint: boolean): void {
    this.eventLogging(CabinetLogEvent.CABINET_SEND_LETTER_MORE_BUTTON_CLICKED, {hasHint})
  }
  // [캐비넷 나도 만들기] 화면 진입
  logCabinetCreateViewed(): void {
    this.eventLogging(CabinetLogEvent.CABINET_CREATE_VIEWED)
  }
  // [캐비넷 나도 만들기] 앱 열기 버튼 클릭
  logCabinetCreateAppOpenButtonClicked(): void {
    this.eventLogging(CabinetLogEvent.CABINET_CREATE_APP_OPEN_BUTTON_CLICKED)
  }

  // [캐비넷 아이디 설정] 화면 진입
  logCabinetIdSettingViewed(): void {
    this.eventLogging(CabinetLogEvent.CABINET_ID_SETTING_VIEWED);
  }
  // [캐비넷 아이디 설정] 시작하기 버튼 클릭
  logCabinetIdSettingSubmit(idLength: number, isEdited: boolean ): void {
    this.eventLogging(CabinetLogEvent.CABINET_ID_SETTING_SUBMIT, {idLength, isEdited});
  }
  // [캐비넷 생성 완료] 화면 진입
  logCabinetCreationSuccessViewed(): void {
    this.eventLogging(CabinetLogEvent.CABINET_CREATION_SUCCESS_VIEWED);
  }
  // [캐비넷 홈] 화면 진입
  logCabinetHomeViewed(): void {
    this.eventLogging(CabinetLogEvent.CABINET_HOME_VIEWED);
  }
  // [캐비넷 홈] 질문 수정 버튼 클릭
  logCabinetHomeUpdateButtonClicked(themeColor?: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_HOME_UPDATE_BUTTON_CLICKED, {themeColor});
  }
  // [캐비넷 홈] 새로고침 버튼 클릭
  logCabinetHomeRandomButtonClicked(beforeThemeColor?: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_HOME_RANDOM_BUTTON_CLICKED, {beforeThemeColor});
  }
  logCabinetHomeCopyLinkButtonClicked(themeColor?: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_HOME_COPY_LINK_BUTTON_CLICKED, {themeColor});
  }
  // [캐비넷] 탭바 클릭
  logCabinetTabBarClicked(to: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_TAB_BAR_CLICKED, {to});
  }
  // [캐비넷 수정] 랜덤 버튼 클릭
  logCabinetUpdateRandomButtonClicked(beforeThemeColor?: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_UPDATE_RANDOM_BUTTON_CLICKED, {beforeThemeColor});
  }
  // [캐비넷 수정] 테마 색상 선택
  logCabinetUpdateThemeColorSelected(themeColor?: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_UPDATE_THEME_COLOR_SELECTED, {themeColor});
  }
  // [캐비넷 수정] 수정 버튼 클릭
  logCabinetUpdateUpdateButtonClicked(themeColor?: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_UPDATE_UPDATE_BUTTON_CLICKED, {themeColor});
  }
  // [캐비넷 수정] 완료 버튼 클릭
  logCabinetUpdateSubmit(themeColor?: string): void {
    this.eventLogging(CabinetLogEvent.CABINET_UPDATE_SUBMIT, {themeColor});
  }
  logHomeCabinetBannerClicked(): void {
    this.eventLogging(CabinetLogEvent.HOME_CABINET_BANNER_CLICKED);
  }
  
  // [캐비넷 온보딩] 화면 진입
  logCabinetOnboardingViewed(): void {
    this.eventLogging(CabinetLogEvent.CABINET_ONBOARDING_VIEWED);
  }
  logCabinetOnboardingSubmit(): void {
    this.eventLogging(CabinetLogEvent.CABINET_ONBOARDING_SUBMIT);
  }

  // [캐비넷 히스토리] 화면 진입
  logCabinetHistoryViewed(newLetterCount: number): void {
    this.eventLogging(CabinetLogEvent.CABINET_HISTORY_VIEWED, {newLetterCount});
  }
  // [캐비넷 히스토리] 스크롤
  logCabinetHistoryScrolled(): void {
    this.eventLogging(CabinetLogEvent.CABINET_HISTORY_SCROLLED);
  }
  // [캐비넷 히스토리] 쪽지 클릭
  logCabinetHistoryLetterClicked(isRead: boolean, isReplied: boolean, imageUrl: string, isSystemMessage: boolean): void {
    this.eventLogging(CabinetLogEvent.CABINET_HISTORY_LETTER_CLICKED, {isRead, isReplied, imageUrl, isSystemMessage});
  }
  // [캐비넷 히스토리] 앱 설치하고 쪽지확인하기 버튼 클릭
  logCabinetHistoryInstallAppClicked(): void {
    this.eventLogging(CabinetLogEvent.CABINET_HISTORY_INSTALL_APP_CLICKED);
  }

  // [캐비넷 설명서] 모달 진입
  logCabinetGuideViewed(): void {
    this.eventLogging(CabinetLogEvent.CABINET_GUIDE_VIEWED);
  }
  // [캐비넷 설명서] 다음 버튼 클릭
  logCabinetGuideNextButtonClicked(stage: number, isDismissClicked: boolean): void {
    this.eventLogging(CabinetLogEvent.CABINET_GUIDE_NEXT_BUTTON_CLICKED, {stage, isDismissClicked});
  }
  // [캐비넷 설명서] 공유 버튼 클릭
  logCabinetGuideInstaShareButtonClicked(isDismissClicked: boolean): void {
    this.eventLogging(CabinetLogEvent.CABINET_GUIDE_INSTA_SHARE_BUTTON_CLICKED, {isDismissClicked});
  }
  // [캐비넷 설명서] 다시 보지 않기 버튼 클릭
  logCabinetGuideRefuseButtonClicked(isDismissClicked: boolean): void {
    this.eventLogging(CabinetLogEvent.CABINET_GUIDE_REFUSE_BUTTON_CLICKED, {isDismissClicked});
  }


  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, {
      category: 'cabinet',
      referralId: this.referralId,
      referralPadId: this.referralPadId,
      referralMethod: this.referralMethod,
      referralUniqueName: this.referralUniqueName,
      ...params
    })
  }
}